import React from 'react';
import {FormattedMessage} from "react-intl";

import './PickMoreOrLess.style.scss';
const PickMoreOrLess = () => {
    return (
        <div className={"PickMoreOrLess"}>
            <div className={'title'}><FormattedMessage id={'landingPage.pickMoreOrLess.title'} values={{
                bold: (chunks) => {
                    const id = typeof chunks === 'string' ? chunks : JSON.stringify(chunks);
                    return <span key={id} className="gold-gradient-text">{chunks}</span>;
                }
            }}/></div>
            <div className={'subtitle'}><FormattedMessage id={'landingPage.pickMoreOrLess.subtitle'}/></div>
            <div className={'pickMoreOrLessImage'}/>
        </div>
    )
}

export default PickMoreOrLess;